import React, { useState } from 'react';
import { DateRangeForm } from 'src/components/DateRangeForm/DateRangeFormNew';
import { observer } from 'src/utils/mobx-react';
import { TransactionHistoryTabState } from './TransactionHistoryTab.state';
import { TransactionsList } from 'src/components/CustomersBar/CustomerTab/TransactionHistoryTab/TransactionsList/TransactionsList';
import { useAppStateContext } from 'src/AppState/AppState';
import { TransactionHistoryTabContent } from './TransactionsList/TransactionList.styles';
import { TransactionHistoryTabItems } from 'src/components/CustomersBar/CustomerTab/TransactionHistoryTab/TransactionHistoryTabItems';

interface InnerType {
    id: string;
    name: string;
}

export interface FiltersType {
    status: Array<InnerType>;
    type: Array<InnerType>;
}

const ALL_FILTERS = (): FiltersType => {
    const type = [
        { id: 'deposit', name: 'Deposit' },
        { id: 'withdrawal', name: 'Withdraw' },
        { id: 'bet', name: 'Bet' },
        { id: 'bonus', name: 'Bonus' },
        { id: 'casino-wager;casino-generic', name: 'Wager' },
        { id: 'virtualsports-wager', name: 'Virtual Sports Wager' },
        { id: 'live-casino-wager;live-casino-generic', name: 'Live Casino Wager' },
    ];

    return {
        status: [
            { id: 'requested', name: 'Requested' },
            { id: 'initiated', name: 'Initiated' },
            { id: 'paid', name: 'Paid' },
        ],
        type: type,
    };
};

const IN_FILTERS: FiltersType = {
    status: [
        { id: 'initiated', name: 'Initiated' },
        { id: 'paid', name: 'Paid' },
    ],
    type: [
        { id: 'deposit', name: 'Deposit' },
        { id: 'bet', name: 'Bet' },
        { id: 'casino-wager;casino-generic', name: 'Wager' },
        { id: 'virtualsports-wager', name: 'Virtual Sports Wager' },
        { id: 'live-casino-wager;live-casino-generic', name: 'Live Casino Wager' },
    ],
};

const OUT_FILTERS: FiltersType = {
    status: [
        { id: 'requested', name: 'Requested' },
        { id: 'paid', name: 'Paid' },
    ],
    type: [
        { id: 'withdrawal', name: 'Withdraw' },
        { id: 'bet', name: 'Bet' },
        { id: 'casino-wager;casino-generic', name: 'Wager' },
        { id: 'virtualsports-wager', name: 'Virtual Sports Wager' },
        { id: 'live-casino-wager;live-casino-generic', name: 'Live Casino Wager' },
    ],
};

interface TransactionHistoryTabPropsType {
    id: number;
}

export const TransactionHistoryTab = observer('TransactionHistoryTab', ({ id }: TransactionHistoryTabPropsType) => {
    const { routerBackoffice, sdkStaff } = useAppStateContext();
    const [state] = useState(() => new TransactionHistoryTabState(id, routerBackoffice, sdkStaff));
    const { range, handleOnUpdateDate, onGenerateCSV, assetFlowsListLength } = state;
    const isDisabled = assetFlowsListLength === 0;

    const allFilters = ALL_FILTERS();
    const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab.tab') ?? 'all';

    return (
        <TransactionHistoryTabContent>
            <DateRangeForm
                data={range}
                handleOnUpdateDate={handleOnUpdateDate}
                onGenerateCSV={onGenerateCSV}
                isDisabled={isDisabled}
            />

            <TransactionHistoryTabItems />
            {customerParams === 'all' && (
                <TransactionsList
                    availableFilters={allFilters}
                    name='all'
                    state={state}
                    userId={id}
                />
            )}

            {customerParams === 'into' && (
                <TransactionsList
                    availableFilters={IN_FILTERS}
                    name='into'
                    state={state}
                    userId={id}
                />
            )}

            {customerParams === 'out' && (
                <TransactionsList
                    availableFilters={OUT_FILTERS}
                    name='out'
                    state={state}
                    userId={id}
                />
            )}
        </TransactionHistoryTabContent>
    );
});
